export default __webpack_public_path__ + "static/Pre-Event-Safety-e4ffbb57392d4bdb61a39eb810002b9e.pdf";